export enum MutationType {
  Comment,
  Snapshot,
  Task,
  Tag,
  Person,
  PersonRelationship,
  DemoReset
}
